import React, { useId } from 'react';
import { Tooltip } from 'react-tooltip';
import styles from './PppnsTooltip.module.scss';

const PppnsTooltip = ({ text = 'pppns', className = '' }) => {
  const tooltipId = useId();

  return (
    <span className={`${styles.pppnsWrap} ${className}`}>
      <span className={styles.pppnsText}>{text}</span>
      <span
        className={styles.infoIcon}
        data-tooltip-id={`pppns-${tooltipId}`}
        aria-label="Per person per night sharing. Does not include Park fees / Transport."
      >
        i
      </span>
      <Tooltip
        id={`pppns-${tooltipId}`}
        className={styles.tooltipBox}
        place="top"
      >
        <span className={styles.tooltipMain}>
          Per person per night sharing
        </span>
        <span className={styles.tooltipNote}>
          Does not include Park fees / Transport.
        </span>
      </Tooltip>
    </span>
  );
};

export default PppnsTooltip;
